module.exports = __webpack_public_path__ + "media/images/user-portal-profile-icon-a32bf62d82af24bf1735a222104ba33a.svg";